import { Route } from '../../store';
import { ReportContainer } from './container';

export const reportRoutes: Route[] = [
  {
    path: '/report',
    component: ReportContainer,
  },
];
